import React, { Component } from "react";
import { Dimmer, Grid, Loader, Container } from "semantic-ui-react";
import PageFooter from "../../../../components/liminal/PageFooter";
import PageHeader from "../../../../components/liminal/PageHeader";
import NotFound from "../../../../components/liminal/NotFound";
import SearchInputGrid from "../../../../components/liminal/SearchInputGrid";
import Comments from "../../../../components/liminal/Comments";
import { Default } from "./Default";
import ObjectSidePanel from "../../../object/components/ObjectSidepanel";
import { SearchSidePanel } from "../../../search/components/SearchSidePanel";
import AnnotationServiceProvider from "../../../annotation/components/Annotation/AnnotationServiceProvider";
import ObjectBreadcrumb from "../../../object/components/ObjectBreadcrumb";
import { ObjectProvider } from "../../../object/components/ObjectProvider";
import { SidePanelControl } from "../../../panels/components/SidePanelControl";

const PanelLoader = ({ loading, size }) => (
  <div className="o-panel__loader">
    <Dimmer active>
      <Loader size={size || "big"} content={`Loading ${loading || "..."}`} />
    </Dimmer>
  </div>
);

class ViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      obj: null,
      error: null,
      searchResults: { hits: [] },
      searchTerm: this.props.search.searchTerm,
      panels: {
        right: true,
        left: true
      }
    };
  }

  getObj = uid => {
    /* If this object is also in the search results of the current section, use _that_ object.
    It saves us a network trip back and forth, and it will have the _searchPrevious and _searchNext properties set on the object for navigation
    */
    if (this.state.obj && uid === this.state.obj.ID[0]) return;
    window._$tarQ.push([
      "track",
      {
        datatype: "DATABASE",
        title: process.env.REACT_APP_PROJECT_NAME,
        itemtype: "RECORD_VIEW"
      }
    ]);
    if (
      this.props.search.cache[this.props.section] &&
      !this.state.skipSearchCache
    ) {
      const theHits = this.props.search.cache[this.props.section].hits;
      for (let i = 0; i < theHits.length; i++) {
        const obj = theHits[i];
        const thisObjID = obj.ID[0];
        if (thisObjID === uid) {
          this.setState({
            similar_images: undefined,
            obj: obj,
            searchResults: { hits: theHits }
          });
          return;
        }
      }
    }
    this.props.search.getObjects(
      [uid],

      getObjectsResults => {
        if (getObjectsResults.notfound.indexOf(uid) > -1) {
          this.setState({ objnotfound: true });
        } else {
          this.setState({
            similar_images: undefined,
            obj: getObjectsResults.hits[0],
            searchResults: { hits: [getObjectsResults.hits[0]] }
          });
        }
      }
    );

    return null;
  };

  functionAfterSearch = () => {
    this.props.history.push(
      `${process.env.REACT_APP_URL_PATH}/section/${this.props.section}`
    );
  };

  doSearch = () => {
    this.setState({ searching: true });
    this.props.search.searchTerm = this.state.searchTerm;
    this.props.search.doSearch(
      this.props.match.params.section,
      this.functionAfterSearch
    );
  };

  toggleSidePanel(side) {
    this.setState(state => ({
      ...state,
      panels: {
        ...state.panels,
        [side]: !state.panels[side]
      }
    }));
  }

  componentDidMount() {
    this.getObj(this.props.match.params.uid);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.getObj(this.props.match.params.uid);
  }

  panelWidth = () =>
    16 - (this.state.panels.left ? 3 : 0) - (this.state.panels.right ? 3 : 0);

  render() {
    if (this.state.objnotfound) {
      return <NotFound history={this.props.history} />;
    }

    const panelLeft = this.state.panels.left && (
      <SearchSidePanel
        obj={this.state.obj}
        {...this.props}
        triggerUpdate={() => {
          this.setState({ foo: Math.random() });
        }}
      />
    );

    const panelRight = this.state.panels.right && (
      <ObjectSidePanel obj={this.state.obj} {...this.props} />
    );

    return (
      <ObjectProvider value={this.state.obj}>
        <AnnotationServiceProvider>
          <PageHeader
            section={this.props.section}
            history={this.props.history}
          />
          <Container>
            <SearchInputGrid
              searchTerm={this.state.searchTerm}
              searching={this.state.searching}
              onChange={event =>
                this.setState({ searchTerm: event.target.value })
              }
              doSearch={this.doSearch}
            />
          </Container>

          <div className="view-page">
            <Grid stackable>
              <Grid.Column className="breadcrumb" width={16}>
                <ObjectBreadcrumb object={this.state.object} />
              </Grid.Column>
              <Grid.Column
                style={{
                  display: this.state.panels.left ? "block" : "none"
                }}
                width={3}
              >
                {panelLeft}
              </Grid.Column>
              <Grid.Column width={this.panelWidth()}>
                <div className="o-panel">
                  {this.state.obj ? (
                    <Default
                      triggerUpdate={() =>
                        this.setState({ foo: Math.random() })
                      }
                      obj={this.state.obj}
                      section={this.props.section}
                      history={this.props.history}
                      search={this.props.search}
                      doSearch={this.doSearch}
                    />
                  ) : (
                    <PanelLoader loading={this.props.match.params.uid} />
                  )}
                  <SidePanelControl
                    openingHint="Show search facets, filters and navigation"
                    closingHint="Hide search facets, filters and navigation"
                    location="left"
                    onToggle={() => {
                      this.toggleSidePanel("left");
                    }}
                    state={this.state.panels.left ? "open" : "closed"}
                  />
                  <SidePanelControl
                    openingHint="Show object metadata and references"
                    closingHint="Hide object metadata and references"
                    onToggle={() => {
                      this.toggleSidePanel("right");
                    }}
                    location="right"
                    state={this.state.panels.right ? "open" : "closed"}
                  />
                </div>
              </Grid.Column>
              <Grid.Column
                style={{ display: this.state.panels.right ? "block" : "none" }}
                width={3}
              >
                {panelRight}
              </Grid.Column>
              {(this.props.section === "him_CERLPDA" ||
                this.props.section === "him_CERLCANYOUHELP") && (
                <Grid.Column width={5}>
                  {this.state.obj &&
                    this.state.obj.HIM.indexOf("CERLCANYOUHELP") > -1 && (
                      <a
                        href={`${
                          process.env.REACT_APP_URL_PATH
                        }/section/him_CERLCANYOUHELP`}
                        style={{ fontSize: "130%", color: "red" }}
                        onClick={() =>
                          this.props.history.push(
                            `${
                              process.env.REACT_APP_URL_PATH
                            }/section/him_CERLCANYOUHELP`
                          )
                        }
                      >
                        Can You Help?
                      </a>
                    )}
                  {this.state.obj ? (
                    <Comments
                      obj={this.state.obj}
                      search={this.props.search}
                      resetAfterSave={() =>
                        this.setState({
                          skipSearchCache: true,
                          obj: null
                        })
                      }
                    />
                  ) : (
                    `Loading ${this.props.match.params.uid}`
                  )}
                </Grid.Column>
              )}
            </Grid>
            <PageFooter />
          </div>
        </AnnotationServiceProvider>
      </ObjectProvider>
    );
  }
}

export default ViewPage;
